export const getWorkflowOffset = (offset) => {
    const match = offset.match(/^(\d+)([dhm])$/);
    if (match) {
        const days = parseInt(match[1], 10);
        const unit = match[2];
        return [days, unit];
    }
    return [0, "m"];
};
export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["Draft"] = "Draft";
    WorkflowStatus["Published"] = "Published";
})(WorkflowStatus || (WorkflowStatus = {}));
export var WorkflowActorMode;
(function (WorkflowActorMode) {
    WorkflowActorMode["DefaultActor"] = "DefaultActor";
    WorkflowActorMode["AssignedUser"] = "AssignedUser";
})(WorkflowActorMode || (WorkflowActorMode = {}));
//# sourceMappingURL=workflow.js.map